import { platforms } from "../../../utils/defaultsProvider";

class MyProfileController {
    /**
     * @param $window
     * @param $location
     * @param $state
     * @param $mdToast
     * @param authService
     * @param userService
     */
    constructor($window, $location, $state, $mdToast, authService, userService) {
        this.$window = $window;
        this.$location = $location;
        this.$state = $state;
        this.$mdToast = $mdToast;
        this.authService = authService;
        this.userService = userService;
        this.profile = {
            platforms: [],
        };
        this.countries = [];
        this.subjects = [];
        this.titles = [];
        this.tempLanguage = '';
        this.selectedLanguage = null;
        this.tempSubject = '';
        this.selectedSubject = null;
        this.allPlatforms = platforms;
    }

    $onInit() {
        this.user = this.userService.currentUser;
        this.userService.getMyProfile(this.userService.currentUser.id)
            .then(profile => this.profile = profile)
            .catch(error => console.error('Can not fetch profile', error));
    }

    changePassword() {
        localStorage.removeItem('kes_email');
        localStorage.removeItem('kes_token');
        this.$window.location.href = '/forgot-password';
    }

    languageSearch(term) {
        //TODO when Backend is ready
        if (term.length < 2) {
            return [];
        }

        pipeDriveService.searchPipeDrives(term).then((res) => {
            this.deals = res.data.data;
            return res.data.data.map(e => {
                return {
                    name: e.title,
                    type: e.type,
                    invitation: new Date(),
                    id: e.id,
                };
            });
        });

        return deferred.promise;
    }

    toggleListMember(item, list) {
        const idx = list.indexOf(item);
        if (idx > -1) {
            list.splice(idx, 1);
        } else {
            list.push(item);
        }
    }

    isOnList(item, list) {
        return list.indexOf(item) > -1;
    }

    onSubmit(form) {
        if (form.$valid) {
            this.userService.saveSmallProfile(this.user)
                .then(() => {
                    this.userService.loadCurrentUser();
                    this.$mdToast.show(
                        this.$mdToast.simple()
                            .textContent('Profile was saved')
                            .position('top center')
                            .action('Hide')
                            .highlightAction(true)
                            .hideDelay(4000)
                            .toastClass('success-toast'),
                    );
                    this.$state.go('home');
                })
                .catch(error => console.error('Can not save profile', error));
        }
    }
}

MyProfileController.$inject = ['$window', '$location', '$state', '$mdToast', 'AuthService', 'UserService'];

export default MyProfileController;



// WEBPACK FOOTER //
// ./src/app/pages/user/myProfile/myProfileController.js